import { useState, useEffect } from "react";
import { sendSupportEmail } from "../../api/mail";
import { getEmail } from "../../api/users";
import toast from "react-hot-toast"

export default function SupportPage() {
    const [subject, setSubject] = useState("");
    const [body, setBody] = useState("");
    const [senderEmail, setSenderEmail] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchEmail = async () => {
            try {
                const data = await getEmail();
                setSenderEmail(data.email || "");
            } catch (err) {
                console.error("Failed to fetch email:", err);
            }
        };
        fetchEmail();
    }, []);

    const handleSubmit = async () => {
        if (!senderEmail) {
            toast.error("Email not loaded yet!");
            return;
        }
        setLoading(true);
        try {
            await sendSupportEmail({ subject, body, sender_email: senderEmail, admin_email: null });
            toast.success("Email sent successfully!");
            setSubject("");
            setBody("");
        } catch (err) {
            console.error(err);
            toast.error("Failed to send email!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="bg-[#F3F4F6] min-h-screen py-8 px-4">
                <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-md p-8">
                    <h1 className="text-2xl font-semibold text-gray-800 mb-2">Contact Support</h1>
                    <p className="text-sm text-gray-500 mb-6">We'll get back to you as soon as possible.</p>

                    <div className="flex flex-col gap-5">

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                            <textarea
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm h-32 resize-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                                value={body}
                                onChange={(e) => setBody(e.target.value)}
                            />
                        </div>

                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="bg-orange-500 text-white font-medium py-2 px-4 rounded-lg hover:bg-orange-600 transition"
                        >
                            {loading ? "Sending..." : "Send"}
                        </button>

                    </div>
                </div>
            </div>
        </>
    );
}
